import { RuntimeBaseError } from "@/domains/errors/kinds/RuntimeBaseError";

export class RuntimeArgumentError extends RuntimeBaseError {}
